//these are public keys
export const REBILLY_ORG_ID = 'd3fbb7ce-c0fb-494b-b7f2-c8987d28f043'
export const REBILLY_PUBLICKEYS = {
  local: 'pk_sandbox_uSCFz8SZ9mExc-kc9rQvMNSo9TycKuS0PtOHoyO',
  prod: 'pk_live_Mpb2Z80I1GVoF334i64_8RtgYEczLyvkk7zJ0KR',
}

export const REBILLY_URLS = {
  local: 'https://api-sandbox.rebilly.com/v2.1',
  prod: 'https://api.rebilly.com/v2.1',
}
